// extracted by mini-css-extract-plugin
export default {"container":"GrowthIndicator_container__lIRyd"};